// extracted by mini-css-extract-plugin
module.exports = {"EditMode":"EditMode_EditMode__3elSG","centered":"EditMode_centered__2HUTp"};